module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoVDjMSMffk+QAAAMxJREFUWMPVl8sOhDAIRaWZ/274clzVMGgtTC40w8qYJufIQ5FE5NgZ7dgcnwoIEV1pFhEqExjg3vvXPS1BWT1ARKLBOpj5ykSrhpc0oYgQM9cL2GbzSDR02lcSuv4wAV3zNwkLh0zBrOEszI4fRGDV7U9PDOsBz6jZcsAEvHOekgEkPCyAhocEMuBugSy4SyATvhTIhr8KVMCnAlXwR4FK+E2gGv7TmxAJDwug4SGBDLhbIAt+W0hm32672US243F+XMNXsr//Od0ucALKWNC05Up3vwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/edit.png
// module id = 33aG
// module chunks = 1